export class VehicleIdentificationScenario {

  constructor(public type: VehicleIdentificationScenarioType) {}

  public isVin() {
    return this.type === VehicleIdentificationScenarioType.VIN;
  }

  public isLicensePlate() {
    return this.type === VehicleIdentificationScenarioType.LICENSE_PLATE;
  }

  public isLicensePlatePicture() {
    return this.type === VehicleIdentificationScenarioType.LICENSE_PLATE_PICTURE;
  }

  public isRegistrationCardPicture() {
    return this.type === VehicleIdentificationScenarioType.REGISTRATION_CARD_PICTURE;
  }

  public isNoIdentification() {
    return this.type === VehicleIdentificationScenarioType.NO_IDENTIFICATION;
  }

}

export enum VehicleIdentificationScenarioType {
  VIN = "VIN",
  LICENSE_PLATE = "LICENSE_PLATE",
  LICENSE_PLATE_PICTURE = "LICENSE_PLATE_PICTURE",
  REGISTRATION_CARD_PICTURE = "REGISTRATION_CARD_PICTURE",
  NO_IDENTIFICATION = "NO_IDENTIFICATION"
}
